import React, { useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import { TextFieldStyled } from "./FormField";
import Box from "@mui/material/Box";

interface SchoolYearPickerProps {
    includeCurrentSchoolYear?: boolean;
    value?: number | "";
    onChange: (dates: [Date, Date], schoolYear: number) => void;
}

const CustomSchoolYearPicker = ({
    includeCurrentSchoolYear = false,
    value = "",
    onChange,
}: SchoolYearPickerProps) => {
    const today = new Date();
    const calendarYear = today.getFullYear();
    const currentSchoolYearStart =
        today >= new Date(calendarYear, 7, 31)
            ? calendarYear
            : calendarYear - 1;

    const arrayLength = includeCurrentSchoolYear ? currentSchoolYearStart - 2017 + 1 : currentSchoolYearStart - 2017;

    const schoolYears = useMemo(
        () =>
            Array.from(
                { length: arrayLength },
                (_, index) => 2017 + index
            ),
        []
    );

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const schoolYearStart = Number(event.target.value);

        if (Number.isNaN(schoolYearStart)) {
            return;
        }

        const startDate = new Date(schoolYearStart, 7, 31);
        const endDate = new Date(schoolYearStart + 1, 7, 31);

        onChange([startDate, endDate], schoolYearStart);
    };

    return (
        <Box
            sx={{ border: "1px solid #ddd", borderRadius: "16px" }}
            width="100%"
        >
            <TextFieldStyled
                fullWidth
                select
                margin="normal"
                label="Selectează anul școlar"
                value={value}
                onChange={handleChange}
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                backgroundColor: "primary.light",
                                borderRadius: "15px",
                            },
                        },
                        BackdropProps: {
                            invisible: true,
                        },
                    },
                }}
            >
                {schoolYears.map((year) => (
                    <MenuItem key={year} value={year}>
                        {year}–{year + 1}
                    </MenuItem>
                ))}
            </TextFieldStyled>
        </Box>
    );
};

export default CustomSchoolYearPicker;